import {
    Dialog,
    DialogActions,
    DialogBody,
    DialogContent,
    DialogProps,
    DialogSurface,
    DialogTitle,
} from '@fluentui/react-components';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { WarningImage } from '../../icons/status';
import { useAppStyles } from '../../styles';
import { TrackContext } from '../common';
import { CancelButton, ConfirmButton } from '../dialogs';
import CloseButton from '../dialogs/close-button';

// Stop sharing project confirmation dialog properties.
export type StopSharingDialogProps = Readonly<
    Partial<DialogProps> & {
        title: string;
        onConfirm: () => void;
    }
>;

// Stop sharing project confirmation dialog.
export default (props: StopSharingDialogProps) => {
    const { title, onConfirm } = props;
    const styles = useAppStyles();

    return (
        <TrackContext.Provider value={{ container: 'stop-sharing-dialog' }}>
            <Dialog {...props}>
                <DialogSurface>
                    <DialogBody>
                        <DialogTitle action={<CloseButton />}>
                            <FormattedMessage
                                description="Stop sharing project dialog title."
                                defaultMessage="Stop sharing"
                            />
                        </DialogTitle>
                        <DialogContent className={styles.flexRowCentered}>
                            <WarningImage className={styles.dialogImage} />
                            <div className={styles.dialogContent}>
                                <div>
                                    <FormattedMessage
                                        description="Confirmation text on Stop Sharing project dialog."
                                        defaultMessage="Are you sure you want to stop sharing source code for project ''{PROJECT_TITLE}''?"
                                        values={{ PROJECT_TITLE: title }}
                                    />
                                </div>
                                <div>
                                    <FormattedMessage
                                        description="Text on Stop Sharing project dialog."
                                        defaultMessage="Everyone you have shared the project with will no longer be able to view the source code."
                                    />
                                </div>
                            </div>
                        </DialogContent>
                        <DialogActions>
                            <CancelButton />
                            <ConfirmButton className={styles.buttonDanger} onClick={onConfirm}>
                                <FormattedMessage
                                    description="Stop sharing project dialog confirmation button text."
                                    defaultMessage="Stop sharing"
                                />
                            </ConfirmButton>
                        </DialogActions>
                    </DialogBody>
                </DialogSurface>
            </Dialog>
        </TrackContext.Provider>
    );
};
